import { gql } from '@apollo/client';

export const GENERATE_SPACE_DOODLES_SEQUENCE = gql`
  mutation GenerateSpaceDoodlesSequence($data: GenerateSequenceInput!) {
    generateSpaceDoodlesSequence(data: $data) {
      id
    }
  }
`;
